export function toValidRuleModel(rule) {
    if (isRuleValid(rule)) {
        return rule;
    }
    return undefined;
}
function isRuleValid(rule) {
    switch (rule.type) {
        case 'all-plugins':
        case 'internal-repo':
            return !!rule.action;
        case 'vendor-plugins':
            return !!rule.vendor && !!rule.vendor.name.length && !!rule.action;
        case 'single-plugin':
            return isSinglePluginRuleValid(rule);
        default:
            return assert_exhaustive(rule);
    }
}
function isSinglePluginRuleValid(rule) {
    var _a;
    if (!rule.action) {
        return false;
    }
    if (!rule.singlePluginTypeRule) {
        return false;
    }
    if (!rule.singlePluginTypeRule.pluginDefinition) {
        return false;
    }
    switch ((_a = rule.singlePluginTypeRule) === null || _a === void 0 ? void 0 : _a.type) {
        case 'bundled':
            return true;
        case 'marketplace':
            return isVersionValid(rule.singlePluginTypeRule.version);
        case 'internal-repo': {
            return (!!rule.singlePluginTypeRule.channel || isVersionValid(rule.singlePluginTypeRule.version));
        }
        default:
            return assert_exhaustive(rule.singlePluginTypeRule);
    }
}
function isVersionValid(version) {
    if (!version) {
        return false;
    }
    switch (version.type) {
        case 'all':
        case 'latest':
            return true;
        case 'custom':
            return !!version.version.trim();
        case 'specific':
            return !!version.version;
        default:
            return assert_exhaustive(version);
    }
}
